import React, { useState } from "react";
import {
    Modal,
    Button,
    Menu,
    Space,
} from "antd";
import {
    QuestionCircleOutlined,
    LaptopOutlined,
    CodeOutlined,
    WindowsOutlined,
    LinuxOutlined
} from "@ant-design/icons";
import ModalLinux from "./ModalLinux";
import ModalLogiciel from "./ModalLogiciel";
import ModalWindows from "./ModalWindows";

const items = [
    {
        label: 'via un logiciel',
        key: 'logiciel',
        icon: <LaptopOutlined />,
    },
    {
        label: 'via une ligne de commande',
        key: 'SubMenu',
        icon: <CodeOutlined />,
        children: [
            {
                label: 'Windows',
                key: 'windows',
                icon: <WindowsOutlined />
            },
            {
                label: 'Linux/Mac',
                key: 'linux',
                icon: <LinuxOutlined />
            },
        ],
    },
];


function ModalComponent(props) {

    const [isModalOpen, setIsModalOpen] = useState(false)

    const [current, setCurrent] = useState('logiciel');

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const onClick = (e) => {
        console.log('click ', e);
        setCurrent(e.key);
    };


    return (
        <>

            <Button
                type="default"
                onClick={showModal}
                icon={<QuestionCircleOutlined />}
            ></Button>

            <Modal
                title="Comment télécharger les données ?"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                width={1000}
                cancelButtonProps={{ style: { display: "none" } }}
            >


                Cette interface vous permet de récupérer la liste des
                données qui vous intéressent.
                Pour récupérer les données facilement, il faudra
                automatiser le téléchargement.
                Pour cela, vous pouvez utiliser un logiciel ou une ligne de commande :
                <br />

                <Menu onClick={onClick} selectedKeys={[current]} mode="horizontal" items={items} />
                <br/>
                {{
                    'logiciel' : <ModalLogiciel/>,
                    'windows': <ModalWindows/>,
                    'linux': <ModalLinux/>

                }[current]

                }

            </Modal>
        </>
    )
}

export default ModalComponent